module.exports = __webpack_public_path__ + "static/z_tall_lessonplans-6db41f1b8a2e360c142d8012bee62181.jpg";